import moment from "moment";
import { useEffect, useState } from "react";
import { IconBarbell, IconCalendar, IconClock } from "@tabler/icons-react";
import TimeUtils from "utils/time";
import Metrics, { PreviousMonthData } from "utils/metrics";
import StatsBar, { StatItem } from "../../components/StatsBar";

interface TopLevelMetricsProps {
  days: number;
  duration: number;
  sessions: number;
  previousMonthData?: PreviousMonthData | null;
}

const TopLevelMetrics = ({
  days,
  duration,
  sessions,
  previousMonthData,
}: TopLevelMetricsProps) => {
  const [abbreviate, setAbbreviate] = useState(true);
  const [deltaDays, setDeltaDays] = useState(0);
  const [deltaDuration, setDeltaDuration] = useState(0);
  const [deltaSessions, setDeltaSessions] = useState(0);

  useEffect(() => {
    const delta = Metrics.calculateDelta(
      { days, duration, sessions },
      previousMonthData
    );
    setDeltaDays(delta.days);
    setDeltaDuration(delta.duration);
    setDeltaSessions(delta.sessions);
  }, [days, duration, sessions, previousMonthData]);

  useEffect(() => {
    const interval = setInterval(() => {
      setAbbreviate((prev) => !prev);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  // Format days value
  const daysValue = abbreviate
    ? `${days.toLocaleString()}d`
    : `${TimeUtils.elapsedToString(
        TimeUtils.breakdown(days * moment.duration(1, "day").asMilliseconds())
      )}${days === 0 ? "d" : ""}`;

  // Format duration value
  const durationValue = TimeUtils.elapsedToString(
    TimeUtils.breakdown(duration, abbreviate),
    2
  );

  const stats: StatItem[] = [
    {
      key: "days",
      icon: <IconCalendar size={24} />,
      value: daysValue,
      label: "Days with Tension",
      color: "primary",
      delta: deltaDays,
    },
    {
      key: "duration",
      icon: <IconClock size={24} />,
      value: durationValue,
      label: "Time under Tension",
      color: "error",
      delta: deltaDuration,
    },
    {
      key: "sessions",
      icon: <IconBarbell size={24} />,
      value: sessions.toLocaleString(),
      label: "Number of Tugs",
      color: "warning",
      delta: deltaSessions,
    },
  ];

  return <StatsBar stats={stats} />;
};

export default TopLevelMetrics;
